import { useState, useCallback, useRef } from "react";

const DEFAULT_TITLE = "Document";

export function useDocumentPanel() {
  const [state, setState] = useState({
    isOpen: false,
    title: DEFAULT_TITLE,
    content: '',
    contentFormat: 'text',
    isSidebarCollapsed: false,
  });

  const lastOpenedFromMessageIdRef = useRef(null);

  const openDocumentPanel = useCallback((options = {}) => {
    lastOpenedFromMessageIdRef.current = options.messageId ?? null;
    setState((prev) => ({
      ...prev,
      isOpen: true,
      title: options.title ?? DEFAULT_TITLE,
      content: options.content ?? '',
      contentFormat: options.format ?? 'text',
      isSidebarCollapsed: true,
    }));
  }, []);

  const closeDocumentPanel = useCallback(() => {
    setState((prev) => ({
      ...prev,
      isOpen: false,
      title: DEFAULT_TITLE,
      content: '',
      contentFormat: 'text',
      isSidebarCollapsed: false,
    }));
  }, []);

  const consumeLastOpenedFromMessageId = useCallback(() => {
    const value = lastOpenedFromMessageIdRef.current;
    lastOpenedFromMessageIdRef.current = null;
    return value;
  }, []);

  const setSidebarCollapsed = useCallback((collapsed) => {
    setState((prev) => ({ ...prev, isSidebarCollapsed: collapsed }));
  }, []);

  return {
    isDocumentPanelOpen: state.isOpen,
    documentPanelTitle: state.title,
    documentPanelContent: state.content,
    documentPanelContentFormat: state.contentFormat,
    isSidebarCollapsed: state.isSidebarCollapsed,
    openDocumentPanel,
    closeDocumentPanel,
    consumeLastOpenedFromMessageId,
    setSidebarCollapsed,
  };
}
